// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"bbcb6457","534":"56e062d9"}[chunkId] + ".chunk.js";
};